<template>
  <RevContextualMenu class="z-10" position="bottom-end">
    <template #trigger="{ show }">
      <RevButtonIcon
        :alternative-text="i18n(translations.avatarIcon)"
        data-qa="profile-menu"
        :icon="IconAvatar"
        variant="secondary"
        @click="show"
      />
    </template>
    <template #items>
      <RevListItemInteractive
        v-if="hasRouteAccess({ name: ROUTE_NAMES.PROFILE.INDEX })"
        :to="{ name: ROUTE_NAMES.PROFILE.INDEX }"
      >
        <template #label>{{ i18n(translations.profile) }}</template>
      </RevListItemInteractive>

      <RevListItemInteractive :to="{ query: { 'file-library': 'true' } }">
        <template #label>{{ i18n(translations.fileLibrary) }}</template>
      </RevListItemInteractive>

      <RevListItemInteractive data-test="action-logout" @click="logout">
        <template #label>{{ i18n(translations.logout) }}</template>
      </RevListItemInteractive>
    </template>
  </RevContextualMenu>
</template>

<script setup lang="ts">
import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevContextualMenu } from '@ds/components/ContextualMenu'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { IconAvatar } from '@ds/icons/IconAvatar'

import { usePermissions } from '~/composables/usePermissions'
import { ROUTE_NAMES } from '~/constants/routes'

import translations from './UserMenu.translations'

const i18n = useI18n()

const { hasRouteAccess } = usePermissions()

const { logout } = useLogout()
</script>
